<div *ngIf="!loading">
<h2 class="text-center">{{country['name']}}</h2>

<table class="table">
  <tr>
    <td>Level Name</td><td>{{country['primaryLevelNaming']}}</td>
  </tr>
  <tr>
    <td>National Curriculum</td><td>{{country['nationalCurriculum']}}</td>
  </tr>
  <tr>
    <td>Primary Leaving Exam</td><td>{{country['primaryLeavingExam']}}</td>
  </tr>
    <tr>
        <td>Alpha2</td><td>{{country['alpha2']}}</td>
    </tr>
    <tr>
        <td>currencyCode</td><td>{{country['currencyCode']}}</td>
    </tr>
    <tr>
        <td>currencySingular</td><td>{{country['currencySingular']}}</td>
    </tr>
    <tr>
        <td>currencyPlural</td><td>{{country['currencyPlural']}}</td>
    </tr>
    <tr>
        <td>currencyAbbreviation</td><td>{{country['currencyAbbreviation']}}</td>
    </tr>
    <tr>
    <td>levelCount</td><td>{{country['levelCount']}}</td>

    </tr>
</table>
<p class="text-center">Levels</p>
<app-list-level-template [levelList]="levelList" *ngIf="levelList"></app-list-level-template>
<app-modal-add-level [country]="country" (addLevelSaveEvent)="saveAddLevel($event)" (levelIndexCloseModalEvent)="closeLevelModal()"> </app-modal-add-level>

<p class = "text-center">
    <a [routerLink]="['/admin/countries/edit',country['server_country_id']]" class="mx-2 btn  btn-primary"><i class="fa fa-edit"> </i>Edit</a>
    <a [routerLink]="['/admin/countries']" class="btn btn-primary"> <i class="fa fa-list"></i> List</a>
    <button (click)="addLevelPopUp()" class="btn btn-primary mx-2">
      <i class="fa fa-plus"></i> Add Level
     </button>
</p>
</div>

<app-spinner *ngIf="loading"></app-spinner>
